import { defineComponent as _defineComponent } from 'vue'
import { useTimelineStore } from '@/js/lib/store/timeline';


export default /*#__PURE__*/_defineComponent({
  __name: 'tab',
  props: {
    current: { default: 'item' }
  },
  setup(__props: any) {


const timelineStore = useTimelineStore();

return { __sfc: true,timelineStore }
}

})